

export interface CustomerCarbonAccountingEnrollmentModel {
    id?: number;
    customerCarbonAccountingEnrollmentId?: number;
    carbonAccountingEnrollmentStatusId: number;
    baselineYear: number;
    baselineYearAsDate: Date;
    targetYear: number;
    targetYearAsDate: Date;
    targetReduction: number;
    ghgTargetReduction: number;
    reportingPeriodTypeId: number;
    financialYearTypeId: number;
    carbonAccountingBallastConfigurationTypeId?: number;
    customerId: number;
    hasSubmittedData: boolean;
    carbonAccountingDataSourceId: number;
}

export interface GetCustomerCarbonAccountingEnrollmentsResponse {
    customerCarbonAccountingEnrollments: CustomerCarbonAccountingEnrollmentModel[];
}

export interface CarbonAccountingSummaryReportDataModel {
    caSummaryDataPerPeriod: CarbonAccountingSummaryData[];
    caReportingDataPerEmissionsRating: CarbonAccountingRatingReport[];
    caReportDataPerVesselType: CarbonAccountingVesselTypeReport[];
    caReportDataPerCargoType: CarbonAccountingCargoTypeReport[];
    highestEmissionsInfo: InsightInfo;
    highestVoyagesInfo: InsightInfo;
    highestCargoInfo: InsightInfo;
}

export interface CarbonAccountingSummaryData {
    periodTypeSkey: number;
    customerDatePeriodValue: number;
    totalGhgEmissions?: number;
    totalDistance?: number;
    totalDwt?: number;
    totalTeu?: number;
    totalCBM?: number;
    totalIntensity?: number;
    cargoTypes?: number;
    voyages?: number;
    vessels?: number;
    year?: number;
    computedUnit?: string;
}

export interface CarbonAccountingRatingReport {
    vessels: number;
    customerDateQuarterSkey: number;
    dateQuarterName: string;
    emissionsRating: string;
    year: number;
}

export interface CarbonAccountingVesselTypeReport {
    totalGhgEmissions?: number;
    totalDwt?: number;
    vessels: number;
    vesselType: string;
    periodTypeSkey: number;
    customerDatePeriodValue: number;
    year: number;
}

export interface CarbonAccountingCargoTypeReport {
    totalGhgEmissions?: number;
    vessels: number;
    cargoUnit: string;
    cargoTypeName: string;
    dateQuarterName: string;
    customerDateQuarterSkey: number;
    year: number;
    totalDwt: number;
    totalTeu: number;
    totalCBM: number;
}

export interface InsightInfo {
    periodName: string;
    percentage: number;
}

export interface GetCarbonAccountingSummaryReportDataRequest {
    customerId?: number;
    fromYear: number;
    toYear: number;
    periodTypeId: number;
    customFilterValue1?: string;
    customFilterValue2?: string;
    customFilterValue3?: string;
    customFilterValue4?: string;
    customFilterValue5?: string;
    customFilterValue6?: string;
}

export interface GetVoyageIdsFromPortRouteRequest {
    portIds: number[];
    customerId?: number;
}

export enum CarbonAccountingEnrollmentStatusEnum {
    Active = 1,
    Inactive = 2
}

export enum FinancialYearTypeEnum {
    January = 1,
    April = 2,
    July = 3,
    October = 4
}

export enum CarbonAccountingBallastConfigurationTypeEnum {
    AllVoyages = 1,
    TCOnly = 2,
    VoyagesWithBallastPort = 3,
    NoVoyages = 4
}

export interface CarbonAccountingCustomReportFilterModel
{
    carbonAccountingCustomReportFilterId?: number;
    customerId: number;
    displayName?: string;
    excelColumn?: string;
    internalColumn?: string;
    dataTypeId?: number;
    isSearchable?: boolean;
}

export interface VoyageDeclarationResponse
{
    enGhgEmissionsWellToTank: number;
    enGhgEmissionsTankToWheels: number;
    enGhgEmissionsWellToWheels: number;
    enGhgEmissionsPCWellToTank: number;
    enGhgEmissionsPCTankToWheels: number;
    enGhgEmissionsPCWellToWheels: number;
    enEnergyWellToTank: number;
    enEnergyTankToWheels: number;
    enEnergyWellToWheels: number;
    enEnergyPCWellToTank: number;
    enEnergyPCTankToWheels: number;
    enEnergyPCWellToWheels: number;
    sccGhgEmissions: number;
    sccTransportWork: number;
    sccActualCO2Intensity: number;
    sccRequiredCO2Intensity: number;
    sccAlignmentDelta: number;
}